import { render } from "./CustomMailPreview.vue?vue&type=template&id=7c357e90"
import script from "./CustomMailPreview.vue?vue&type=script&lang=js"
export * from "./CustomMailPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__